export default function getQueryParamValue(location,key){
    if(location){
        const query = new URLSearchParams(location.search);
        const param = query.get(key)

        return param
    }

    return null
}